import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Requisition, UpdateRequisitionRequest } from "@/types";

export function useUpdateRequisition() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      id,
      updateRequisitionRequest,
    }: {
      id: number;
      updateRequisitionRequest: UpdateRequisitionRequest;
    }) => {
      const path = `jobs/${currentJobId}/requisitions/${id.toString()}`;
      const res = await guacHttpClient.patch<
        Requisition,
        HttpResponse<Requisition>,
        UpdateRequisitionRequest
      >(path, updateRequisitionRequest);

      return res.data;
    },
    onSuccess: () => {
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });
    },
  });

  return mutation;
}
